import { computed, inject, Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { GlobalAppApi } from '@features/global/api/global-app.api';
import { GlobalAppSettings, InstallationRegion } from '@features/global/global-app.model';
import { IcuDay } from '@features/process/intensive-care/icu-day';

// Как на сервере (IntensiveCareDay): пока начало суток не задано, сутки начинаются в 09:00.
const DEFAULT_ICU_DAY_START_OFFSET = 9 * 60;

@Injectable({ providedIn: 'root' })
export class GlobalAppSettingsService {
  private api = inject(GlobalAppApi);

  private settings$ = signal<GlobalAppSettings>(null);

  readonly region$ = computed<InstallationRegion>(() => this.settings$()?.region ?? 'rf');

  load(): Observable<GlobalAppSettings> {
    return this.loadState().pipe(map((state) => state.settings));
  }

  /** То же, что load(), плюс признак «требуется перезагрузка системы». */
  loadState() {
    return this.api.get().pipe(
      tap(({ settings }) => this.settings$.set(settings)),
      tap(({ settings }) => IcuDay.setStartOfDayOffset(settings?.icu?.icuDayStartOffset ?? DEFAULT_ICU_DAY_START_OFFSET)),
    );
  }
}
